import React from 'react';

interface ACHIconProps {
  height?: number;
  width?: number;
  color?: string;
}

const ACHIcon: React.FC<ACHIconProps> = ({ height, width, color = '#62CFF0' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      viewBox="0 0 500 500"
      width={`${width}pt`}
      height={`${height}pt`}
    >
      <path
        style={{ fill: color }}
        d="m180.54 254.94-2.26-27.19-8.23 6.67-.06-.07a64 64 0 0 0-3.91-4.27 65.14 65.14 0 0 0-110 58.63l9.81-1.93A55.14 55.14 0 0 1 159 237.15c1.13 1.13 2.24 2.34 3.27 3.57l-7.86 6.37ZM69.8 318.12l.06.07c1.25 1.49 2.56 2.93 3.91 4.28A65.14 65.14 0 0 0 183.36 262l-9.75 2.2a55.14 55.14 0 0 1-92.77 51.17 58 58 0 0 1-3.27-3.56l7.87-6.38-25.94-8.2 2.07 27.55Z"
      ></path>
      <path
        style={{ fill: color }}
        d="M121.61 315.89v-7.59a23.5 23.5 0 0 0 10.54-3.37 19.46 19.46 0 0 0 6.74-6.93 17.85 17.85 0 0 0 2.3-8.81q0-6.18-2.72-9.7a16.16 16.16 0 0 0-6.65-5.15 69 69 0 0 0-10.21-3.14V251a10.1 10.1 0 0 1 5.25 3.14 9.16 9.16 0 0 1 2.24 5.2h11.43q-.65-7.77-5.66-12.22t-13.26-5.2v-7.59h-6.09v7.59q-8.8.84-14.24 6a16.9 16.9 0 0 0-5.43 12.88q0 6.18 2.76 9.74a16.23 16.23 0 0 0 6.7 5.2 75 75 0 0 0 10.21 3.23v20.61a9.58 9.58 0 0 1-5.9-3 10.08 10.08 0 0 1-2.34-6H95.85a15.52 15.52 0 0 0 5.43 12.36q5.43 4.69 14.24 5.53v7.59Zm0-35.41a16.9 16.9 0 0 1 6.51 3.42 7.53 7.53 0 0 1 2.3 5.85 9.42 9.42 0 0 1-2.35 6.42 10.4 10.4 0 0 1-6.46 3.32ZM109 266.14a7.8 7.8 0 0 1-2.3-6 9 9 0 0 1 2.39-6.56 10.37 10.37 0 0 1 6.42-2.91v18.93a16.6 16.6 0 0 1-6.51-3.46"
      ></path>
      <path
        style={{ fill: color }}
        d="M472 260.24a5 5 0 0 0-5 5v129.29a11.86 11.86 0 0 1-11.86 11.85H25.26a11.86 11.86 0 0 1-11.85-11.85V166.61a11.86 11.86 0 0 1 11.85-11.85h429.88A11.86 11.86 0 0 1 467 166.61v26.2a5 5 0 0 0 10 0v-26.2a21.88 21.88 0 0 0-21.86-21.85H25.26a21.87 21.87 0 0 0-21.85 21.85v227.92a21.87 21.87 0 0 0 21.85 21.85h429.88A21.88 21.88 0 0 0 477 394.53V265.24a5 5 0 0 0-5-5"
      ></path>
      <path
        style={{ fill: color }}
        d="M451.55 224.17a5 5 0 0 0 5-5v-44.36a9.62 9.62 0 0 0-9.61-9.6H33.47a9.62 9.62 0 0 0-9.61 9.6v211.51a9.62 9.62 0 0 0 9.61 9.61h413.47a9.62 9.62 0 0 0 9.61-9.61V291.6a5 5 0 0 0-10 0v94.33H33.86V175.21h412.69v44a5 5 0 0 0 5 4.96"
      ></path>
      <path
        style={{ fill: color }}
        d="M392.3 268.83a5 5 0 0 0-5-5H214.13a5 5 0 0 0 0 10H387.3a5 5 0 0 0 5-5M302.53 298.09h-88.4a5 5 0 0 0 0 10h88.4a5 5 0 0 0 0-10M209.13 337.36a5 5 0 0 0 5 5h118.16a5 5 0 1 0 0-10H214.13a5 5 0 0 0-5 5"
      ></path>
      <path
        style={{ fill: color }}
        d="m374.87 311.03-50.98-27.59 55.89 63.99 117.38-141.72zM222.9 239h15.85l2.41 7.29h13.12l-16.23-44.7h-14.33l-16.29 44.7h13.06Zm7.92-24 4.82 14.46h-9.57ZM278.88 212.57a8.66 8.66 0 0 1 8.24 5.2h13.38a20.27 20.27 0 0 0-7.35-12.14 22.15 22.15 0 0 0-14.08-4.47 23.2 23.2 0 0 0-11.66 2.84 19.77 19.77 0 0 0-7.83 8.05 26.58 26.58 0 0 0 0 23.59 19.77 19.77 0 0 0 7.83 8 23.2 23.2 0 0 0 11.66 2.89 22.15 22.15 0 0 0 14.08-4.47A20.3 20.3 0 0 0 300.5 230h-13.38a8.93 8.93 0 0 1-3.32 3.87 9.07 9.07 0 0 1-4.92 1.33 8.5 8.5 0 0 1-6.88-3.07 14.56 14.56 0 0 1 0-16.49 8.5 8.5 0 0 1 6.88-3.07M306.4 201.6v44.7h12.43v-17.95h15.15v17.95h12.43v-44.7h-12.43v16.8h-15.15v-16.8z"
      ></path>
    </svg>
  );
};

export default ACHIcon;
